import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { languages } from 'src/app/demo/constants/languages';
import { PaymentVerification } from 'src/app/demo/models/payment-verification';
import { LanguageService } from 'src/app/demo/service/language.service';
import { PaymentVerificationsService } from 'src/app/demo/service/payment-verifications.service';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { NgxTranslateModule } from 'src/app/translate.module';

@Component({
  selector: 'app-payment-verifications-list',
  standalone: true,
  imports: [CommonModule, NgxTranslateModule, ButtonModule, TableModule, InputTextModule, InputGroupModule, TooltipModule],
  templateUrl: './payment-verifications-list.component.html',
  styleUrl: './payment-verifications-list.component.scss'
})
export class PaymentVerificationsListComponent {

  verifications: PaymentVerification[] = [];
  languages: any[] = languages;
  selectedLanguage!: string;
  initializeLocale() {
    this.languageService.currentLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.setLanguage(this.selectedLanguage);
    });
  }

  setLanguage(language: string) {
    this.translateService.use(language);
    this.languageService.setLanguage(language);
  }

  ngOnInit() {
    this.fetchVerifications();
    this.initializeLocale();
  }

  constructor(private paymentsVerificationService: PaymentVerificationsService,
    private translateService: TranslateService, private languageService: LanguageService,
    private progressLoaderService: ProgressLoaderService, private router: Router) {

  }

  fetchVerifications() {
    this.progressLoaderService.show()
    this.paymentsVerificationService.getAllPaymentVerifications().subscribe({
      next: value => {
        this.progressLoaderService.hide()
        this.verifications = value;
      },
      error: err => {
        this.progressLoaderService.hide()
      }
    })
  }

  viewPaymentVerification(verification: PaymentVerification) {
    this.router.navigate([`/home/payment-verifications/${verification.id}`])
  }

  newVerificationClicked() {
    this.router.navigate(['/home/new-payment-verification'])
  }
}
